import React from 'react';

const FloppyEmoji = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33333 30C3.33333 30 0 30 0 26.6667V3.33333C0 3.33333 0 0 3.33333 0H25C25.8333 0 26.6667 0.833333 26.6667 0.833333L29.1667 3.33333C29.1667 3.33333 30 4.16667 30 5V26.6667C30 26.6667 30 30 26.6667 30H3.33333Z"
        fill="#31373D"
      />
      <path
        d="M4.16666 15.8333V15C4.16666 15 4.16666 13.3333 5.83333 13.3333H23.3333C25 13.3333 25 15 25 15V15.8333H4.16666Z"
        fill="#55ACEE"
      />
      <path
        d="M4.16666 26.6842V15.8333H25V26.6667C25 26.6667 25 28.3333 23.3333 28.3333H5.83333C4.16666 28.3333 4.16666 26.6842 4.16666 26.6842ZM8.33333 2.50001C8.33333 2.50001 8.33333 1.66667 9.16666 1.66667H24.1667C25.04 1.66667 25 2.50001 25 2.50001V10.8333C25 10.8333 25 11.6667 24.1667 11.6667H9.16666C9.16666 11.6667 8.33333 11.6667 8.33333 10.8333V2.50001ZM18.3333 10.8333H22.5V2.50001H18.3333V10.8333Z"
        fill="#E1E8ED"
      />
    </svg>
  );
};

export default FloppyEmoji;
